import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import { systemReducer } from "./system/systemReducer";
import { DEPSReducer } from "./dashboardEPS/dEpsReducer";
import { DSalesReducer } from "./dashboardSales/dSalesReducer";
import { DUsersReducer } from "./dashboardUsers/dUsersReducer";
import { DEncashReducer } from "./dashboardEncash/dEncashReducer";
import { DOrdersReducer } from "./dashboardOrders/dOrdersReducer";
import { DStoresReducer } from "./dashboardStores/dStoresReducer";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { DRefundsReducer } from "./dashboardRefunds/dRefundsReducer";
import { DTicketsReducer } from "./dashboardTickets/dTicketsReducer";
import { SettingsReducer } from "./dashboardSettings/settingsReducer";
import { DZreportsReducer } from "./dashboardZreports/dZreportReducer";
import { DSalesArchiveReducer } from "./dashboardSalesArchive/reducer";
import { DProductsReducer } from "./dashboardProducts/dProductsReducer";
import { DOrdersArchiveReducer } from "./dashboardOrdersArchive/reducer";
import { DRefundsArchiveReducer } from "./dashboardRefundsArchive/reducer";
import { DCashDesksReducer } from "./dashboardCashDesks/dCashDesksReducer";
import { DCategoriesReducer } from "./dashboardCategories/dCategoriesReducer";
import { DStatisticsReducer } from "./dashboardStatistics/dStatisticsReducer";
import { DEdmProductsReducer } from "./dashboardEdmProducts/dEdmProductsReducer";
import { DHandoverRecordReducer } from "./dashboardHandoverRecord/dHandoverRecordReducer";
import { DPosConfigurationReducer } from "./dashboardPosConfiguration/dPosConfigurationReducer";
import { DTransferCashDesksReducer } from "./dashboardTransferCashDesks/dTransferCashDesksReducer";

export const sagaMiddleware = createSagaMiddleware();

export const history = createBrowserHistory();

const rootReducer = combineReducers({
  dEps: DEPSReducer,
  system: systemReducer,
  dSales: DSalesReducer,
  dUsers: DUsersReducer,
  dEncash: DEncashReducer,
  dOrders: DOrdersReducer,
  dStores: DStoresReducer,
  dTickets: DTicketsReducer,
  settings: SettingsReducer,
  dRefunds: DRefundsReducer,
  dZReports: DZreportsReducer,
  dProducts: DProductsReducer,
  dCashDesks: DCashDesksReducer,
  dCategories: DCategoriesReducer,
  dStatistics: DStatisticsReducer,
  dHRecord: DHandoverRecordReducer,
  dEdmProducts: DEdmProductsReducer,
  dSalesArchive: DSalesArchiveReducer,
  dOrdersArchive: DOrdersArchiveReducer,
  dRefundsArchive: DRefundsArchiveReducer,
  dPosConfiguration: DPosConfigurationReducer,
  dTransferCashDesks: DTransferCashDesksReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ["payload.formData"],
      },
    }).concat(sagaMiddleware),
});

export const maxAge = 43200;

export const setAuthCookies = (token: string, refreshToken: string) => {
  document.cookie = `tindaToken=${token}; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=${maxAge}`;
  document.cookie = `tindaRefreshToken=${refreshToken}; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=${maxAge}`;
};

export type RootState = ReturnType<typeof store.getState>;
